import If from "../../../../if"
import Tooltip from "../../../../tool-tip"
import Badge from "../../../../badge"
import { useGetAdvisorSessionsQuery } from "../../../../../../redux/queries"

interface Props {
  className?: string
  subscriptionId: string
  dashboardPageviewCount: number
  rateAlertEmailOpenCount: number
  smsAllowed: number
  smsFollowupSent?: "0" | "1"
}

const EngagementsEvents = ({
  className,
  subscriptionId,
  dashboardPageviewCount,
  rateAlertEmailOpenCount,
  smsAllowed,
  smsFollowupSent
}: Props) => {
  const isSMSSent = !!smsAllowed && smsFollowupSent === "1"

  const eventCount = dashboardPageviewCount + rateAlertEmailOpenCount

  const { data: sessionsPage } = useGetAdvisorSessionsQuery({
    page: 1,
    limit: 100
  })
  const session = sessionsPage?.conversations?.find(
    s => s.subscriptionId === subscriptionId
  )
  const promptCount = Math.floor((session?.messageCount ?? 0) / 2)

  return (
    <If
      condition={eventCount > 0 || isSMSSent || promptCount > 0}
      then={
        <>
          <If
            condition={isSMSSent}
            then={
              <Badge.Alt className={`${className} ml-1`}>SMS sent</Badge.Alt>
            }
          />
          <If
            condition={eventCount > 0}
            then={
              <Tooltip
                displayTextClass="justify-self-start ml-1"
                toolTipNode={<span>🔥 {eventCount}+</span>}
                text={
                  <ul className="text-[10px]">
                    <If
                      condition={dashboardPageviewCount > 0}
                      then={
                        <li>
                          <span className="inline-block mr-1 -rotate-90">
                            🧲
                          </span>
                          &nbsp;Dashboard pageview {dashboardPageviewCount}x
                        </li>
                      }
                    />
                    <If
                      condition={rateAlertEmailOpenCount > 0}
                      then={
                        <li>
                          <span className="inline-block mr-1">📧</span>
                          &nbsp;Rate alert opened {rateAlertEmailOpenCount}x
                        </li>
                      }
                    />
                  </ul>
                }
                placement="top"
              />
            }
          />
          <If
            condition={promptCount > 0}
            then={
              <Tooltip
                displayTextClass="justify-self-start ml-1"
                toolTipNode={<span>🤖 {promptCount}+</span>}
                text={
                  <span className="text-[10px]">
                    AI Advisor prompts {promptCount}x
                  </span>
                }
                placement="top"
              />
            }
          />
        </>
      }
    />
  )
}

export default EngagementsEvents
